import { type FC } from 'react'

import { Box, Icon, type LargeIcon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  icon: LargeIcon
  title: string
  label: string
}

const Blank: FC<Props> = ({ icon, title, label }) => (
  <Box
    alignItems="center"
    justifyContent="center"
    textAlign="center"
    height="s400"
    paddingX="s64"
    gap="s24"
  >
    <Icon.Large color="grey600" icon={icon} />
    <Box gap="s8">
      <Text.Normal weight="semibold" color="grey1000">
        {title}
      </Text.Normal>
      <Text.Normal color="grey1000">{label}</Text.Normal>
    </Box>
  </Box>
)

export default Blank
